import { render, staticRenderFns } from "./xuexin.vue?vue&type=template&id=3463e5de"
import script from "./xuexin.vue?vue&type=script&lang=js"
export * from "./xuexin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports